import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function Invoice() {
  const [invoice, setInvoice] = useState({
    currency: "₹",
    currentDate: new Date().toLocaleDateString(),
    invoiceNumber: 1,
    billTo: "",
    billToAddress: "",
    billToEmail: "",
    billFrom: "Vaibhavam",
    billFromAddress: "Tamil Nadu, India",
    notes: "",
    subTotal: "0.00",
    taxRate: 0,
    taxAmount: "0.00",
  });

  const invoiceRef = useRef(null);

  // ✅ handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoice((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ calculate total
  const calculateTotal = () => {
    const subTotal = parseFloat(invoice.subTotal) || 0;
    const taxRate = parseFloat(invoice.taxRate) || 0;
    const taxAmount = (subTotal * taxRate) / 100;
    return (subTotal + taxAmount).toFixed(2);
  };

  // ✅ download invoice as PDF
  const downloadPDF = () => {
    const input = invoiceRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`invoice_${invoice.invoiceNumber}.pdf`);
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Invoice Generator</h2>

      {/* Form */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          name="billTo"
          placeholder="Bill To"
          value={invoice.billTo}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
        <input
          type="text"
          name="billToAddress"
          placeholder="Bill To Address"
          value={invoice.billToAddress}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
        <input
          type="email"
          name="billToEmail"
          placeholder="Bill To Email"
          value={invoice.billToEmail}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
        <input
          type="number"
          name="subTotal"
          placeholder="Subtotal"
          value={invoice.subTotal}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
        <input
          type="number"
          name="taxRate"
          placeholder="Tax %"
          value={invoice.taxRate}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
        <textarea
          name="notes"
          placeholder="Notes"
          value={invoice.notes}
          onChange={handleChange}
          style={{ margin: "5px" }}
        />
      </div>

      {/* Invoice Preview */}
      <div
        ref={invoiceRef}
        style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          background: "#fff",
          width: "600px",
        }}
      >
        <h3>Invoice #{invoice.invoiceNumber}</h3>
        <p>Date: {invoice.currentDate}</p>
        <p>
          <strong>From:</strong> {invoice.billFrom}, {invoice.billFromAddress}
        </p>
        <p>
          <strong>To:</strong> {invoice.billTo || "Customer Name"},{" "}
          {invoice.billToAddress}
        </p>
        <p>Email: {invoice.billToEmail || "example@email.com"}</p>

        <hr />
        <p>
          Subtotal: {invoice.currency}
          {parseFloat(invoice.subTotal).toFixed(2)}
        </p>
        <p>
          Tax ({invoice.taxRate}%): {invoice.currency}
          {((parseFloat(invoice.subTotal) * invoice.taxRate) / 100).toFixed(2)}
        </p>
        <h4>
          Total: {invoice.currency}
          {calculateTotal()}
        </h4>
        <hr />
        <p>Notes: {invoice.notes || "N/A"}</p>
      </div>

      {/* Download button */}
      <button
        onClick={downloadPDF}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "green",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Download PDF
      </button>
    </div>
  );
}
